import React, { useState, useEffect, useContext, useMemo } from "react";
import { AuthContext } from "../../../contexts/AuthContext";
import {
  Col,
  Row,
  Form,
  Button,
  FormGroup,
  Label,
  Input,
  Spinner,
  Modal,
  ModalHeader,
  ModalBody,
} from "reactstrap";
import axios from "axios";
import SweetAlert from "sweetalert2-react";
import Swal from "sweetalert2";
import Header from "../../../layout/Header/Header";
import { v4 as uuidv4 } from "uuid";
import { makeStyles } from "@material-ui/core/styles";
import moment from "moment";

const useStyles = makeStyles((theme) => ({
  root: {
    "& .MuiTextField-root": {
      margin: theme.spacing(1),
    },
  },
  button: {
    margin: theme.spacing(1),
  },
}));

function FacturasCreate() {
  const { user } = useContext(AuthContext);
  const URL_LOGS = process.env.REACT_APP_URL_LOGS;
  const URL_SERIES = process.env.REACT_APP_URL_SERIES;
  const URL_TIMBRAR = process.env.REACT_APP_URL_TIMBRAR;
  const URL_FACTURAS = process.env.REACT_APP_URL_FACTURAS;
  const URL_ARTICULOS_SURTIDOS = process.env.REACT_APP_URL_ARTICULOS_SURTIDOS;
  const URL_SURTIDOS = process.env.REACT_APP_URL_SURTIDOS;
  const URL_CLIENTES = process.env.REACT_APP_URL_CLIENTES;
  const URL_EMPRESAS = process.env.REACT_APP_URL_EMPRESAS;
  const URL_COLABORADORES = process.env.REACT_APP_URL_COLABORADORES;

  let date = new Date();
  let hoy = moment(date).format("YYYY-MM-DD");

  const [modalProgreso, setModalProgreso] = useState(false);
  const toggleProgreso = () => setModalProgreso(!modalProgreso);
  const [fecha, setFecha] = useState(hoy);
  const [observaciones, setObservaciones] = useState("NA");
  const [IVAIncluido, setIVAIncluido] = useState("No");
  
  const [timbresDisponibles, setTimbresDisponibles] = useState(0);

  const [subTotal, setSubTotal] = useState(0);
  const [iva, setIva] = useState(0);
  const [total, setTotal] = useState(0);
  const [totalCant, setTotalCant] = useState(0);
  const [descuentoMonto, setDescuentoMonto] = useState(0);
  const [descuento, setDescuento] = useState(0);

  const [surtidos, setSurtidos] = useState([]);

  const [clientes, setClientes] = useState([]);
  const [empresas, setEmpresas] = useState([]);
  const [colaboradores, setColaboradores] = useState([]);
  const [selectedCliente, setSelectedCliente] = useState("");
  const [selectedEmpresa, setSelectedEmpresa] = useState("");
  const [selectedColaborador, setSelectedColaborador] = useState("");

  const [cpEmpresa, setCpEmpresa] = useState("");
  const [rfcEmpresa, setRfcEmpresa] = useState("");
  const [nombreEmpresa, setNombreEmpresa] = useState("");
  const [regFiscalEmpresa, setRegFiscalEmpresa] = useState("");

  const [condicionesPagoSATCliente, setCondicionesPagoSATCliente] = useState("")
  const [formaPagoSATCliente, setFormaPagoSATCliente] = useState("")
  const [metodoPagoSATCliente, setMetodoPagoSATCliente] = useState("")
  const [rfcCliente, setRfcCliente] = useState("")
  const [nombreCliente, setNombreCliente] = useState("")
  const [usoCFDICliente, setUsoCFDICliente] = useState("")
  const [regFiscalCliente, setRegFiscalCliente] = useState("")
  const [cpCliente, setCpCliente] = useState("")

  const [serie, setSerie] = useState("")

  const classes = useStyles();
  const [inputFields, setInputFields] = useState([]);

  const [surtidosData, setSurtidosData] = useState([]);
  const ordenTallas = ["EXTRA CHICA", "CHICA", "M", "MEDIANA", "GRANDE", "EXTRA GRANDE", "VARIOS", "INDIVIDUAL", "MATRIMONIAL", "QUEEN", "KING", "32", "34", "36", "38", "40", "42"];

  const [validaBoton, setValidaBoton] = useState(true);

  useEffect(() => {
    axios
    .get(`${URL_CLIENTES}`, { 
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
      .then((res) => {
        const allClientes = res.data;
        setClientes(allClientes);
      })
      .catch((err) => {
        console.log(err);
      });

      axios
      .get(`${URL_SERIES}Timbres`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allTimbres = res.data;
          setTimbresDisponibles(allTimbres[0].folio);
        })
        .catch((err) => {
          console.log(err);
        });
     
      axios
      .get(`${URL_EMPRESAS}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allEmpresas = res.data;
          setEmpresas(allEmpresas);
        })
        .catch((err) => {
          console.log(err);
        });
        axios
        .get(`${URL_COLABORADORES}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allColaboradores = res.data;
            setColaboradores(allColaboradores);
          })
          .catch((err) => {
            console.log(err);
          });
  }, []);

const saveFacturaNuevo = async (event) => {
  event.preventDefault();

  const headers = {
    Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  };

  const onlyCode = (v) => String(v ?? "").trim().split(" ")[0]; // "02 Cheque..." => "02"

  const showErr = (error, titulo = "Error") => {
    const payload =
      error?.response?.data ??
      { message: error?.message, code: error?.code };

    const msg = JSON.stringify(payload, null, 2);

    Swal.fire({
      icon: "error",
      title: titulo,
      text: "Ocurrió un error",
      footer: `<pre style="text-align:left;white-space:pre-wrap;max-height:260px;overflow:auto">${msg}</pre>`,
    });

    console.log("❌ FRONT ERROR:", error);
  };

  try {
    if (!(timbresDisponibles > 0)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "No cuenta con timbres disponibles",
      });
      return;
    }

    const result = await Swal.fire({
      title: "Estas seguro?",
      text: "Se guardará la Factura!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Si, guardar!",
    });

    if (!result.isConfirmed) return;

    if (!(subTotal > 0 && total > 0)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "Faltan Datos",
      });
      return;
    }

    setValidaBoton(false);
    toggleProgreso();

    // ✅ Sanitizar a SOLO código
    const fp = onlyCode(formaPagoSATCliente);     // "02"
    const mp = onlyCode(metodoPagoSATCliente);    // "PUE" o "PPD"

    console.log("🚀 UI PAGO:", { formaPagoSATCliente, metodoPagoSATCliente, fp, mp, IVAIncluido });

    // 1) Crear factura (guardas también pago en BD)
    const facturaResp = await axios.post(
      URL_FACTURAS,
      {
        fecha,
        observaciones,
        totalCantidad: totalCant,
        subTotal: Number(subTotal.toFixed(2)),
        iva: Number(iva.toFixed(2)),
        total: Number(total.toFixed(2)),
        saldo: Number(total.toFixed(2)),

        descuentoPorcentaje1: Number(descuento.toFixed(2)),
        descuentoNumero1: Number(descuentoMonto.toFixed(2)),
        descuentoConcepto1: "NA",
        descuentoPorcentaje2: 0,
        descuentoNumero2: 0,
        descuentoConcepto2: "NA",

        abonos: 0,
        pagado: "No",

        empresas: selectedEmpresa,
        clientes: selectedCliente,
        colaboradores: selectedColaborador,

        timbre: "No",
        currency: "MXN",
        cfdiType: "I",

        serie,
        expeditionPlace: cpEmpresa,

        rfcEmpresa,
        nombreEmpresa,
        regFiscalEmpresa,

        condicionesPagoSATCliente,
        formaPagoSATCliente: fp,      // ✅ guarda ya el código
        metodoPagoSATCliente: mp,     // ✅ guarda ya el código
        rfcCliente,
        nombreCliente,
        usoCFDICliente,
        regFiscalCliente,
        cpCliente,

        numeroPagos: 0,
      },
      { headers }
    );

    const facturaId = facturaResp.data?._id;
    if (!facturaId) throw new Error("No regresó _id de factura");

    // 2) Amarrar surtidos a factura (NO facturar)
    await Promise.all(
      inputFields.map((w) =>
        axios.patch(
          `${URL_SURTIDOS}Factura/${w.surtidos}`,
          { facturas: facturaId, facturado: "No" },
          { headers }
        )
      )
    );

    // 3) Timbrar (✅ manda fp/mp explícito)
    try {
      console.log("🚀 TIMBRAR SEND:", { facturaId, fp, mp, IVAIncluido });

      await axios.post(
        `${URL_TIMBRAR}Factura`,
        {
          facturas: facturaId,
          IVAIncluido,
          formaPagoSATCliente: fp,    // ✅
          metodoPagoSATCliente: mp,   // ✅
        },
        { headers }
      );
    } catch (errTimbrar) {
      // rollback: desamarrar surtidos
      try {
        await Promise.all(
          inputFields.map((w) =>
            axios.patch(
              `${URL_SURTIDOS}Factura/${w.surtidos}`,
              { facturas: null, facturado: "No" },
              { headers }
            )
          )
        );
      } catch (errRollback) {
        console.log("❗ Error en rollback:", errRollback);
      }
      throw errTimbrar;
    }

    // 4) Logs
    await axios.post(
      URL_LOGS,
      {
        tipo: "Crear Factura",
        detalle: `Fecha Factura ${fecha} ${facturaResp.data?.idFactura || ""}`,
        user: user.id,
      },
      { headers }
    );

    Swal.fire("Good job!", "Creado con exito", "success");
    setTimeout(() => window.location.reload(), 1000);
  } catch (error) {
    const data = error?.response?.data;

    if (data?.badItems?.length) {
      const lista = data.badItems
        .map((x) => `#${x.idx}  SAT:${x.ProductCode}  SKU:${x.IdentificationNumber}\n${x.Description}`)
        .join("\n\n");

      Swal.fire({
        icon: "error",
        title: "Error en conceptos (SAT)",
        text: "Estos conceptos traen datos inválidos:",
        footer: `<pre style="text-align:left;white-space:pre-wrap;max-height:260px;overflow:auto">${lista}</pre>`,
      });

      setValidaBoton(true);
      setModalProgreso(false);
      return;
    }

    showErr(error, "No se pudo crear/timbrar");
    setValidaBoton(true);
    setModalProgreso(false);
  }
};

  
  const handleAddFields = () => {
    setInputFields([
      ...inputFields,
      {
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      },
    ]);
  };


  const handleRemoveFields = (id) => {
    const values = [...inputFields];
    values.splice(
      values.findIndex((value) => value.id === id),
      1
    );
    setInputFields(values);

    let din = values.map((c) => parseFloat(c.total));
    let TD = din.reduce((t, total, index) => t + total, 0);
    setSubTotal(TD);

    let iva = (TD) * 0.16;
    setIva(iva);

    let total = (TD) + iva;
    setTotal(total);
  };


  function BuscaCliente(event) {
    setSelectedCliente(event.target.value)
    setSurtidosData([])

    setInputFields(
      [{
        id: uuidv4(),
        surtidos: "",
        idSurtido: "",
        total: 0,
        totalCantidad: 0,
      }]
      );

    clientes.map((a)=>{
      if(a._id == event.target.value){
      setCondicionesPagoSATCliente(a.condicionesPagoSAT)
      setRfcCliente(a.RFC)
      setNombreCliente(a.razon_social)
      setUsoCFDICliente(a.usoCFDI)
      setRegFiscalCliente(a.regFiscal)
      setCpCliente(a.cp)
      setSelectedColaborador(a.vendedor?.[0]?._id)

      if(a.metodoPagoSAT != "PPD"){
      setFormaPagoSATCliente(a.formaPagoSAT)
      setMetodoPagoSATCliente(a.metodoPagoSAT)
      }else{
        setFormaPagoSATCliente("99")
        setMetodoPagoSATCliente(a.metodoPagoSAT)
      }

      if(event.target.value != "" && selectedEmpresa != ""){
        axios
        .get(`${URL_SURTIDOS}Facturacion/${event.target.value}`, { 
        // .get(`${URL_SURTIDOS}Facturacion/${event.target.value}/${selectedEmpresa}`, { 
            headers: {
              Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
            },
          })
          .then((res) => {
            const allSurtidos = res.data;
            let arrayTabla = allSurtidos.map((a)=>{
              return {
                id: uuidv4(),
                surtidos: a._id,
                idSurtido: a.idSurtido,
                total: a.subTotal,
                totalCantidad: a.total_cantidad,
                descuento: a.descuento,
                // articulo: a.articulos?.[0]?.codigo
              }
            })
            let dataFinal = Object.values(arrayTabla);
            setSurtidos(dataFinal);
          })
          .catch((err) => {
            console.log(err);
          });
      }

    }
    })



  }

  function BuscaEmpresa(event) {
    setSelectedEmpresa(event.target.value)

    empresas.map((a)=>{
      if(a._id == event.target.value){
        setCpEmpresa(a.cp)
        setRfcEmpresa(a.rfc)
        setNombreEmpresa(a.razonSocial)
        setRegFiscalEmpresa(a.regimenFiscal)
      }
    })
    setInputFields(
    [{
      id: uuidv4(),
      surtidos: "",
      idSurtido: "",
      total: 0,
      totalCantidad: 0,
    }]
    );
    if(event.target.value != "" && selectedCliente != ""){
      axios
      .get(`${URL_SURTIDOS}Facturacion/${selectedCliente}`, { 
      // .get(`${URL_SURTIDOS}Facturacion/${selectedCliente}/${event.target.value}`, { 
          headers: {
            Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
          },
        })
        .then((res) => {
          const allSurtidos = res.data;
          let arrayTabla = allSurtidos.map((a)=>{
            return {
              id: uuidv4(),
              surtidos: a._id,
              idSurtido: a.idSurtido,
              total: a.subTotal,
              totalCantidad: a.total_cantidad,
              descuento: a.descuento,
              // articulo: a.articulos?.[0]?.codigo
            }
          })
          let dataFinal = Object.values(arrayTabla);
          setSurtidos(dataFinal);
        })
        .catch((err) => {
          console.log(err);
        });
    }
  }

  // function BuscaColaborador(event) {
  //   setSelectedColaborador(event.target.value)
  //   setInputFields(
  //   [{
  //     id: uuidv4(),
  //     surtidos: "",
  //     idSurtido: "",
  //     total: 0,
  //     totalCantidad: 0,
  //   }]
  //   );
  //   if(event.target.value != "" && selectedCliente != "" && selectedEmpresa != ""){
  //     axios
  //     .get(`${URL_SURTIDOS}Facturacion/${selectedCliente}/${event.target.value}/${selectedEmpresa}`, { 
  //         headers: {
  //           Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //         },
  //       })
  //       .then((res) => {
  //         const allSurtidos = res.data;
  //         let arrayTabla = allSurtidos.map((a)=>{
  //           return {
  //             id: uuidv4(),
  //             surtidos: a._id,
  //             idSurtido: a.idSurtido,
  //             total: a.subTotal,
  //             totalCantidad: a.total_cantidad,
  //           }
  //         })
  //         let dataFinal = Object.values(arrayTabla);
  //         setSurtidos(dataFinal);
  //       })
  //       .catch((err) => {
  //         console.log(err);
  //       });
  //   }
  // }

  // async function BuscaSurtido(id, event) {
  //   if (
  //     inputFields.filter((e) => e.surtidos == event.target.value).length >
  //     0
  //   ) {
  //     Swal.fire({
  //       icon: "error",
  //       title: "Oops...",
  //       text: "El surtido ya fue capturado!",
  //       showConfirmButton: false,
  //     });
  //     const newInputFields = inputFields.map((i) => {
  //       if (id === i.id) {
  //         i.surtidos = "";
  //       }
  //       return i;
  //     });
  //     setInputFields(newInputFields);
  //   } else {
  //     await axios
  //     .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${idPDFOC}`, {
  //       headers: {
  //         Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
  //       },
  //     })
  //     .then((response) => {
  //       let allArticulosSurtido = response.data;
  //       let colorTallaCantidad = {};
  //       let precio = response.data?.[0]?.articulosPedido[0].precio;

  //       allArticulosSurtido.forEach((a) => {
  //         const color = a.colores?.[0]?.name;
  //         const talla = a.tallas?.[0]?.name;
  //         const cantidad = a.cantidad;

  //         if (!colorTallaCantidad[talla]) {
  //           colorTallaCantidad[talla] = {};
  //         }
  //         if (!colorTallaCantidad[talla][color]) {
  //           colorTallaCantidad[talla][color] = 0;
  //         }
  //         colorTallaCantidad[talla][color] += cantidad;
  //       });

  //       const tallas = Object.keys(colorTallaCantidad).sort((a, b) => {
  //         const indexA = ordenTallas.indexOf(a);
  //         const indexB = ordenTallas.indexOf(b);
        
  //         // Si alguna talla no está en el orden definido, coloca al final
  //         return (indexA === -1 ? Infinity : indexA) - (indexB === -1 ? Infinity : indexB);
  //       });
  //       const colores = [
  //         ...new Set(allArticulosSurtido.map((a) => a.colores?.[0]?.name)),
  //       ].sort();
  //     })
  //     .catch((err) => {
  //       console.log(err);
  //     })

  //     surtidos.map((a) => {
  //       if (a.surtidos == event.target.value) {
  //         console.log("holaa", a)
  //         let surtidos = a.surtidos;
  //         let idSurtido = a.idSurtido;
  //         let total = a.total
  //         let totalCantidad = a.totalCantidad
  //         handleChangeInputArticulo(id, surtidos, idSurtido, total, totalCantidad);
  //       }
  //     });
  //   }
  // }

  async function BuscaSurtido(id, event) {
    setSurtidosData([])
  
    if (inputFields.some((e) => e.surtidos === event.target.value)) {
      Swal.fire({
        icon: "error",
        title: "Oops...",
        text: "El surtido ya fue capturado!",
        showConfirmButton: false,
      });
  
      setInputFields(inputFields.map((i) => (i.id === id ? { ...i, surtidos: "" } : i)));
      return;
    }
  
    try {
      surtidos.map((a) => {
         if (a.surtidos == event.target.value) {
           let surtidos = a.surtidos;
           let idSurtido = a.idSurtido;
           let total = a.total
           let totalCantidad = a.totalCantidad
           let descuento = a.descuento || 0;
           handleChangeInputArticulo(id, surtidos, idSurtido, total, totalCantidad, descuento);
         }
       });
       
      const response = await axios
      .get(`${URL_ARTICULOS_SURTIDOS}/surtido/${event.target.value}`, {
        headers: {
          Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
        },
      })
        let allArticulosSurtido = response.data;
        let arrayTabla = allArticulosSurtido
        .filter(a => a.articulosPedido[0]?.precio > 0) // <-- filtro aquí
          .map((a) => {
            return {
              codigo: a.articulos?.[0]?.codigo,
              articulos: a.articulos?.[0]?.codigo + " " + a.articulos?.[0]?.nombre,
              codigoSAT: a.articulos?.[0]?.codigoSAT,
              cantidad: a.cantidad,
              idArticulo: a.articulos?.[0]?._id,
              precio: a.articulosPedido?.[0]?.precio,
              cajas: a.cantidad / a.articulos?.[0]?.piezasPorCaja,
            };
          })
          .filter(function (el) {
            return el != null;
          });

        let dataFinal = Object.values(arrayTabla);

        let agrupado = dataFinal.reduce(function (groups, item) {
          const val = item["idArticulo"];
          groups[val] = groups[val] || {
            idArticulo: item.idArticulo,
            cantidad: 0,
            cajas: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].cajas += item.cajas;
          groups[val].articulos = item.articulos;
          groups[val].codigoSAT = item.codigoSAT;
          groups[val].precio = item.precio;
          groups[val].codigo = item.codigo;
          return groups;
        }, []);

        let agrupadoValues = Object.values(agrupado);
        setSurtidosData(agrupadoValues);
  
  
  
    } catch (err) {
      console.error("Error en la petición a la API:", err);
    }
  }
  

  const handleChangeInputArticulo = (id, surtidos, idSurtido, total, totalCantidad, descuento) => {
    const newInputFields = inputFields.map((i) => {
      if (id === i.id) {
        i.surtidos = surtidos;
        i.idSurtido = idSurtido;
        i.total = total;
        i.totalCantidad = totalCantidad
        i.descuento = descuento
      }
      return i;
    });
    setInputFields(newInputFields);
    ActualizaTotales();
  };


// function ActualizaTotales() {
//   let totalSinDescuento = 0;
//   let totalConDescuento = 0;
//   let sumaDescuentos = 0;
//   let itemsConDescuento = 0;

//   inputFields.forEach((c) => {
//     let total = parseFloat(c.total) || 0;
//     let descuento = parseFloat(c.descuento) || 0;
//     let totalConDesc = total - (total * descuento / 100);

//     totalSinDescuento += total;
//     totalConDescuento += totalConDesc;

//     if (descuento > 0) {
//       sumaDescuentos += descuento;
//       itemsConDescuento++;
//     }
//   });

//   let montoDescuento = totalSinDescuento - totalConDescuento;
//   setDescuentoMonto(Number(montoDescuento.toFixed(2)));

//   // ✅ Descuento promedio aplicado en porcentaje
//   const descuentoPromedio = itemsConDescuento > 0 ? sumaDescuentos / itemsConDescuento : 0;
//   setDescuento(Number(descuentoPromedio.toFixed(2))); // 👈 Porcentaje promedio

//   // ✅ Subtotal sin descuento
//   setSubTotal(Number(totalSinDescuento.toFixed(2)));

//   // ✅ Total de cantidades
//   let totalCantidad = inputFields.reduce((acc, c) => acc + (parseFloat(c.totalCantidad) || 0), 0);
//   setTotalCant(totalCantidad);

//   // ✅ IVA sobre el total con descuento
//   let iva = totalConDescuento * 0.16;
//   setIva(Number(iva.toFixed(2)));

//   // ✅ Total final con descuento + IVA
//   let total = totalConDescuento + iva;
//   setTotal(Number(total.toFixed(2)));
// }

function ActualizaTotales(ivaIncluidoParam = IVAIncluido) {
  let totalSinDescuento = 0;     // suma de c.total (tal cual venga)
  let totalConDescuento = 0;     // suma de c.total ya con descuento aplicado
  let sumaDescuentos = 0;
  let itemsConDescuento = 0;

  inputFields.forEach((c) => {
    const total = parseFloat(c.total) || 0;          // 👈 si IVAIncluido=="Si", esto ya trae IVA
    const descuento = parseFloat(c.descuento) || 0;

    const totalConDesc = total - (total * descuento / 100);

    totalSinDescuento += total;
    totalConDescuento += totalConDesc;

    if (descuento > 0) {
      sumaDescuentos += descuento;
      itemsConDescuento++;
    }
  });

  // monto de descuento (en $)
  const montoDescuento = totalSinDescuento - totalConDescuento;
  setDescuentoMonto(Number(montoDescuento.toFixed(2)));

  // % descuento promedio
  const descuentoPromedio = itemsConDescuento > 0 ? (sumaDescuentos / itemsConDescuento) : 0;
  setDescuento(Number(descuentoPromedio.toFixed(2)));

  // total cantidades
  const totalCantidad = inputFields.reduce(
    (acc, c) => acc + (parseFloat(c.totalCantidad) || 0),
    0
  );
  setTotalCant(totalCantidad);

  const tasaIVA = 0.16;

  if (ivaIncluidoParam === "No") {
    // Subtotal = totalConDescuento (base)
    setSubTotal(Number(totalConDescuento.toFixed(2)));

    const iva = totalConDescuento * tasaIVA;
    setIva(Number(iva.toFixed(2)));

    const totalFinal = totalConDescuento + iva;
    setTotal(Number(totalFinal.toFixed(2)));
  } else {
    // IVA ya incluido en totalConDescuento, solo se desglosa
    const iva = totalConDescuento * (tasaIVA / (1 + tasaIVA)); // 16/116
    const sub = totalConDescuento - iva;

    setSubTotal(Number(sub.toFixed(2)));       // base sin IVA
    setIva(Number(iva.toFixed(2)));            // IVA desglosado
    setTotal(Number(totalConDescuento.toFixed(2))); // total ya con IVA incluido
  }
}

 

  return (
    <>
      <Header />
      <br />
      <br />
      {user.facturasFiscal ? (
        <div className="card container col-10">
          <h3 align="center">Nuevo Factura</h3>
          <Form onSubmit={saveFacturaNuevo}>
            <Row>
            <Col md={2}>
                <Label>Timbres Disponibles</Label>
                <Input
                  type="text"
                  value={timbresDisponibles}
                  required
                  disabled
                />
              </Col>
            </Row>
            <Row>
              <Col md={2}>
                <Label>Fecha Factura</Label>
                <Input
                  type="date"
                  placeholder="Fecha"
                  value={fecha}
                  required
                  disabled
                />
              </Col>
              <Col md={2}>
                <Label>Empresa</Label>
                    <Input
                      name="empresa"
                      type="select"
                      value={selectedEmpresa}
                      required
                      onChange={(event) => {
                        BuscaEmpresa(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {empresas
                        .sort((a, b) =>
                        a.name > b.name ? 1 : -1
                      )
                      .map((a) => {
                        if(a.listoFacturar == "Si" && a.is_active == "Si"){
                          return (
                            <option value={a._id}>{a.name}</option>
                          );}
                      })}
                    </Input>
                  </Col>

                  <Col md={2}>
                <Label>Cliente</Label>
                    <Input
                      type="select"
                      value={selectedCliente}
                      required
                      onChange={(event) => {
                        BuscaCliente(event);
                      }}
                    >
                      <option value="">Selecciona un Cliente</option>
                      {clientes
                        .sort((a, b) =>
                        a.razon_social > b.razon_social ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.razon_social} / {a.nombre_comercial}</option>
                          );
                      })}
                    </Input>
                  </Col>

                  {/* <Col md={2}>
                <Label>Vendedor</Label>
                    <Input
                      type="select"
                      value={selectedColaborador}
                      required
                      onChange={(event) => {
                        BuscaColaborador(event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {colaboradores
                        .sort((a, b) =>
                        a.nombre > b.nombre ? 1 : -1
                      )
                      .map((a) => {
                          return (
                            <option value={a._id}>{a.nombre} {a.apellido} </option>
                          );
                      })}
                    </Input>
                  </Col> */}

                  <Col md={2}>
                <Label>Serie</Label>
                    <Input
                      type="select"
                      value={serie}
                      required
                      onChange={(event) => {
                        setSerie(event.target.value);
                      }}
                    >
                      <option value="">Selecciona</option>
                      <option value="F">F</option>
                    </Input>
                  </Col>
                  <Col md={2}>
                <Label>Forma Pago Fiscal</Label>
                <Input
                  type="select"
                  value={formaPagoSATCliente}
                  required
                  onChange={(e) => {
                    setFormaPagoSATCliente(e.target.value);
                  }}
                >
              <option value="">Selecciona</option>
              <option value="01"> 01 Efectivo</option>
              <option value="02"> 02 Cheque nominativo</option>
              <option value="03"> 03 Transferencia electrónica de fondos</option>
              <option value="04"> 04 Tarjeta de crédito</option>
              <option value="05"> 05 Monedero electrónico</option>
              <option value="06"> 06 Dinero electrónico</option>
              <option value="08"> 08 Vales de despensa</option>
              <option value="12"> 12 Dación en pago</option>
              <option value="13"> 13 Pago por subrogación</option>
              <option value="14"> 14 Pago por consignación</option>
              <option value="15"> 15 Condonación</option>
              <option value="17"> 17 Compensación</option>
              <option value="23"> 23 Novación</option>
              <option value="24"> 24 Confusión</option>
              <option value="25"> 25 Remisión de deuda</option>
              <option value="26"> 26 Prescripción o caducidad</option>
              <option value="27"> 27 A satisfacción del acreedor</option>
              <option value="28"> 28 Tarjeta de débito</option>
              <option value="29"> 29 Tarjeta de servicios</option>
              <option value="30"> 30 Aplicación de anticipos</option>
              <option value="99"> 99 Por definir</option>
                </Input>
              </Col>

               <Col md={2}>
                <Label>IVA Incluido</Label>
                    <Input
                      type="select"
                      value={IVAIncluido}
                      required
                      onChange={(event) => {
                        setIVAIncluido(event.target.value);
                        ActualizaTotales(event.target.value); 
                      }}
                    >
                      <option value="No">No</option>
                      <option value="Si">Si</option>
                    </Input>
                  </Col>

                  </Row>
             <Row>
              <Col md={4}>
                <Label for="exampleEmail" className="mr-sm-2">
                  Observaciones
                </Label>
                <Input
                  type="text"
                  placeholder="Observaciones"
                  value={observaciones}
                  required
                  onChange={(e) => {
                    setObservaciones(e.target.value);
                  }}
                />
              </Col>
            </Row>


            <Row>
              <Col md={3}>
                <Label className="mr-sm-2">Nota</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Subtotal</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Descuento</Label>
              </Col>
              <Col md={1}>
                <Label className="mr-sm-2">Total</Label>
              </Col>
            </Row>
            {inputFields.map((inputField) => (
              <div key={inputField.id}>
                <Row>
                  <Col md={3}>
                    <Input
                      bsSize="sm"
                      name="surtidos"
                      type="select"
                      value={inputField.surtidos}
                      required
                      onChange={(event) => {
                        BuscaSurtido(inputField.id, event);
                      }}
                    >
                      <option value="">Selecciona</option>
                      {surtidos
                      .sort((a, b) => (a.idSurtido > b.idSurtido ? 1 : -1))
                      .map((a) => {
                        return (
                          <option value={a.surtidos}>
                            Surt: {a.idSurtido}  Cant: {a.totalCantidad}
                          </option>
                        );
                      })}
                    </Input>
                  </Col>

<Col md={1} className="d-flex align-items-center">
  <h6>
    {new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(inputField.total)}
  </h6>
</Col>

<Col md={1} className="d-flex align-items-center">
  <h6>
    {inputField.descuento}%
  </h6>
</Col>
<Col md={1} className="d-flex align-items-center">
  <h6>
    {new Intl.NumberFormat("es-MX", { style: "currency", currency: "MXN" }).format(inputField.total - (inputField.total * inputField.descuento / 100))}
  </h6>
</Col>
                  {/* <Col>
                    <Button
                      size="sm"
                      className="btn"
                      color="danger"
                      disabled={inputFields.length === 1}
                      onClick={() => handleRemoveFields(inputField.id)}
                      tabindex="-1"
                    >
                      <i class="fas fa-minus"></i>
                    </Button>
                    <Button
                      size="sm"
                      className="btn"
                      color="info"
                      onClick={handleAddFields}
                      tabindex="-1"
                    >
                      <i class="fas fa-plus"></i>
                    </Button>
                  </Col> */}
                </Row>
              </div>
            ))}
<br />
            {/* Tabla Articulos */}
            {surtidosData.length > 0 && (
  <div className="container">
    <div className="row justify-content-center">
      <div className="col-12">
        <table className="table table-bordered table-hover">
          <thead className="thead-light">
            <tr>
              <th>Articulo</th>
              <th>Codigo SAT</th>
              <th>Cantidad</th>
              <th>Precio</th>
              <th>Total</th>
            </tr>
          </thead>
          <tbody>
            {surtidosData.map((a, index) => (
              <tr
      key={index}
      style={
        a.codigoSAT === "NA"
          ? {
              backgroundColor: "#ed8c8c", // rojo claro
              // color: "#721c24",           // rojo oscuro para texto
              // fontWeight: "bold",
            }
          : {}
      }
    >
                <td>{a.articulos}</td>
                <td>{a.codigoSAT}</td>
                <td>{a.cantidad}</td>
                <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.precio)}</td>
                <td>{new Intl.NumberFormat("en-US", {style: "currency", currency: "USD", maximumFractionDigits: 2}).format(a.cantidad * a.precio)}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  </div>
)}



       
            <br />
            <br />
            <Row>
            <Col>
            <Label className="mr-sm-2">Subtotal</Label>
            <Input
              type="number"
              value={subTotal}
              disabled
            />
            </Col>
            <Col>
            <Label className="mr-sm-2">Descuento</Label>
            <Input
              type="number"
              value={descuentoMonto}
              disabled
            />
            </Col>
            <Col>
            <Label className="mr-sm-2">IVA</Label>
            <Input
              type="number"
              value={iva}
              disabled
            />
            </Col>
            <Col>
            <Label className="mr-sm-2">Total</Label>
            <Input
              type="number"
              value={total}
              disabled
            />
            </Col>
            </Row>

            <br />
            {validaBoton ? (
              <Button type="submit" className="btn btn-success">
                Guardar
              </Button>
            ) : (
              <Button type="submit" className="btn btn-success" disabled>
                Guardar
              </Button>
            )}
            <Button
              href="/ListadoFacturas"
              className="btn btn-danger"
              id="botonListado"
            >
              Regresar
            </Button>
          </Form>
          <br />
          <Modal size="sm" isOpen={modalProgreso} toggle={toggleProgreso}>
            <ModalHeader toggle={toggleProgreso}>
              <h4>Progreso</h4>
            </ModalHeader>
            <ModalBody>
              <h4>
                {" "}
                Este proceso puede tardar varios segundos.
                <br />
                Por favor no cierre ni refresque su navegador.
              </h4>
              <br />
              <div className="progreso">
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
                <Spinner
                  style={{
                    width: "50px",
                    height: "50px",
                    color: "#232B41",
                  }}
                />
              </div>
            </ModalBody>
          </Modal>
        </div>
      ) : undefined}
    </>
  );
}

export default FacturasCreate;
